import styled, { css } from 'styled-components'
import { ThemeColors } from 'src/shared/ui/consts-styles'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 0.6rem;
    width: 100%;
    font-size: inherit;
    box-sizing: border-box;
    max-width: 18.4rem;
    overflow-x: auto;
    max-height: 23rem;
`

export const Title = styled.div`
    font-size: 0.9rem;
    font-weight: normal;
    color: ${ThemeColors.getGrayColor(0.9)};
    margin-bottom: 0.5rem;
`

interface StyledLinkProps {
    isSelected: boolean
    paddingLeft: number
}

export const StyledLink = styled.span<StyledLinkProps>`
    font-size: 0.8rem;
    color: ${ThemeColors.getGrayColor(0.8)};
    cursor: pointer;
    user-select: none;
    text-decoration: none;
    transition: color 0.3s ease;
    padding-left: ${(props) => props.paddingLeft}px;
    ${(props) =>
        props.isSelected &&
        css`
            font-weight: bold;
            font-size: 0.85rem;
        `}
    & :hover {
        color: ${ThemeColors.accentGreen};
        transition: color 0.3s ease;
    }
`

export const CountBlock = styled.span`
    white-space: nowrap;
`

export const ChildNavItemsContainer = styled.div`
    padding-left: 0.75rem;
`

export const NavItemContainer = styled.div`
    margin: 0;
    padding: 0.2rem 0;
`
